export const boardContextEn = {
  settings: 'Board settings',
  buttonBoard: 'Board',
  boardViewHint: 'Show board',
  addTask: 'Add task',
  titlePlaceholder: 'Type a board name…',
  settingFor: (boardName: string) => `Board settings "${boardName}"`,
  counterInColumns: 'Number of tasks in columns',
  counterInColumnsHint1: 'Number of tasks in a column',
  counterInColumnsHint2: 'Number of tasks in summary'
}

export const boardContextRu = {
  settings: 'Настройки доски',
  buttonBoard: 'Доска',
  boardViewHint: 'Показать доску',
  addTask: 'Добавить задачу',
  titlePlaceholder: 'Название доски…',
  settingFor: (boardName: string) => `Настройки доски «${boardName}»`,
  counterInColumns: 'Количество задач в колонках',
  counterInColumnsHint1: 'Количество задач в колонке',
  counterInColumnsHint2: 'Количество задач в сводке'
}

export const boardCrmContextEn = {
  settings: 'Funnel settings',
  buttonBoard: 'Funnel',
  boardViewHint: 'Show funnel',
  addTask: 'Add deal',
  titlePlaceholder: 'Type a funnel name…',
  settingFor: (boardName: string) => `Funnel settings "${boardName}"`,
  counterInColumns: 'Number of deals in columns',
  counterInColumnsHint1: 'Number of deals in a column',
  counterInColumnsHint2: 'Number of deals in summary'
}

export const boardCrmContextRu = {
  settings: 'Настройки воронки',
  buttonBoard: 'Воронка',
  boardViewHint: 'Показать воронку',
  addTask: 'Добавить сделку',
  titlePlaceholder: 'Название воронки…',
  settingFor: (boardName: string) => `Настройки воронки «${boardName}»`,
  counterInColumns: 'Количество сделок в колонках',
  counterInColumnsHint1: 'Количество сделок в колонке',
  counterInColumnsHint2: 'Количество сделок в сводке'
}
